import React from 'react';

const Sidebar = ({ selected, onSelect }) => {
  return (
    <div style={{
      width: '250px',
      backgroundColor: '#2c3e50',
      color: 'white',
      padding: '20px',
      height: '100vh'
    }}>
      <h3>Admin Panel</h3>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        <li style={menuItemStyle(selected === 'create')} onClick={() => onSelect('create')}>Create User</li>
        <li style={menuItemStyle(selected === 'assign')} onClick={() => onSelect('assign')}>Assign User to Website</li>
        {/* <li style={menuItemStyle(selected === 'remove')} onClick={() => onSelect('remove')}>Remove User from Website</li> */}
      </ul>
    </div>
  );
};

const menuItemStyle = (active) => ({
  padding: '10px',
  cursor: 'pointer',
  backgroundColor: active ? '#34495e' : 'transparent'
});

export default Sidebar;
